import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import {
    createDataSource,
    createGridOptions,
    DataGrid,
    indexCellRenderer,
    LinkCellRenderer,
    TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class OperationalCategoriesIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        const yesNo = [
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
        ];
        this.state = {
            loading: true,
            rowData: [],
            yesNo,
        };
        this.onAddOperationalCategory = this.onAddOperationalCategory.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = () => {
        const context = this;

        const gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        const yesNoFilterParams = {
            suppressFilterButton: true,
            options: this.state.yesNo,
            optionsLabel: 'label',
            optionsValue: 'value',
            initialFilterValue: '',
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 80,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Name',
                sortable: false,
                headerName: 'Name',
                field: 'name',
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.OperationalCategory}/${id}`,
                    nameField: 'name',
                    idField: 'id',
                    title: 'View this Operational Category',
                },
                filter: 'agTextColumnFilter',
                filterParams: TextFilterDefaults,
                floatingFilter: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
            },
            {
                colId: 'IsActive',
                headerName: 'Active',
                field: 'isActive',
                sortable: true,
                flex: 1.5,
                tooltipField: 'status',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: yesNoFilterParams,
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: yesNoFilterParams,
            },
        ];

        gridOptions.postProcessData = (data) => {
            context.setState({
                rowData: data.rows,
            });

            return { ...data };
        };

        gridOptions.onGridReady = (params) => {
            params.api.setDatasource(context.state.dataSource);
            context.setState({ gridApi: params.api });
        };

        const ds = createDataSource(
            ApiRoutes.operationalCategories.search(),
            gridOptions,
        );

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    onAddOperationalCategory = () => {
        this.context.history.push(`${AppNavPaths.OperationalCategoryNew}`);
    };

    render() {
        if (this.state.loading) return <Progress />;
        const { rowData, gridOptions } = this.state;
        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faClock}
                        className="mr-2 text-muted"
                    />
                    <span>Operational Categories</span>
                </PageHeading>
                <DataGridToolbar
                    entity="operationalcategory"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddOperationalCategory}
                    addLabel="Add Operational Category"
                    hideExcelButton
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default OperationalCategoriesIndex;
